import { LineChart } from '@mui/x-charts/LineChart';
import { axisClasses } from '@mui/x-charts/ChartsAxis';
import { chartsGridClasses } from '@mui/x-charts/ChartsGrid';
import { useEffect, useState } from 'react';


function WeightChart({ details }) {
    const [smallSize, setSmallSize] = useState(false)
    const weights = details.map(item => item.data.calculate_current_weight);

    // Find the highest and lowest weights
    const maxWeight = Math.max(...weights);
    const minWeight = Math.min(...weights);
    const increments = 4;  // Number of increments

    const start = Math.ceil(((minWeight - 60) > 0 ? (minWeight - 60) : 0) / 10) * 10;
    const end = Math.ceil(maxWeight / 10) * 10;
    const difference = end - start;
    const x = Math.ceil(difference / increments / 10) * 10;
    const sequence = Array.from({ length: increments }, (_, i) => start + i * x);

    useEffect(() => {
        // Function to update the window width
        const handleResize = () => {
            if (window.innerWidth < 700) {
                setSmallSize(true)
            } else {
                setSmallSize(false)
            }
        };

        handleResize()

        // Attach the resize event listener
        window.addEventListener('resize', handleResize);

        // Clean up the event listener on unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div>
            <LineChart
                dataset={details.map(day => day.data)}
                sx={{
                    [`.${axisClasses.root}`]: {
                        [`.${axisClasses.tick}, .${axisClasses.line}`]: {
                            stroke: 'transparent',
                            strokeWidth: 3,
                        },
                    },
                    [`.${chartsGridClasses.line}`]: {
                        strokeDasharray: '5 3',
                        strokeWidth: 1
                    },
                    '& .MuiAreaElement-series-weight': {
                        fill: "url('#weightGradient')",
                    },
                }}
                grid={{ horizontal: true }}
                xAxis={[{
                    scaleType: 'band',
                    tickFontSize: 14,
                    tickLabelStyle: {
                        fontFamily: 'Inter',
                        fontWeight: '600',
                        fill: '#96948F',
                    },
                    tickSize: 20,
                    data: details.map(day => day.label)
                }]}
                yAxis={[{
                    tickFontSize: 14,
                    tickLabelStyle: {
                        fontFamily: 'Inter',
                        fontWeight: '600',
                        fill: '#96948F',

                    },
                    tickInterval: sequence,
                    min: (minWeight - 60 > 0) ? (minWeight - 60) : 0,
                    tickSize: 10,
                }]}
                slotProps={{ legend: { hidden: true } }}
                series={[
                    { id: 'weight', dataKey: 'calculate_current_weight', label: 'Weight', color: '#299257', area: true, showMark: false, }
                ]}
                margin={{ right: 0, top: 40 }}
                borderRadius={6}
                height={400}
            >
                <defs>
                    <linearGradient id="weightGradient" gradientTransform="rotate(90)">
                        <stop offset="0%" stopColor="#29925733" />
                        <stop offset="20%" stopColor="#29925700" />
                    </linearGradient>
                </defs>
            </LineChart>
        </div >
    );
}


export default WeightChart;